export const capitalizeFirstLetter = (str?: string) => {
  return str ? str.charAt(0).toUpperCase() + str.toLowerCase().slice(1) : '';
};
